export enum featureNames {
  calendarRollover = 'calendarRollover',
  createDiscount = 'createDiscount',
  discountDetails = 'discountDetails',
  fobAdjustment = 'fobAdjustment',
  frontlineDetails = 'frontlineDetails',
  nationalFOBDelete = 'nationalFOBDelete',
  massCopyFrom = 'massCopyFrom',
  massCopyTo = 'massCopyTo',
  newBrandPackage = 'newBrandPackage',
  planDetails = 'planDetails'
}
